import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  RegistrationRequestService,
  UserRegistrationRequest,
} from 'src/app/Services/RegistrationRequest/registration-request.service';

@Component({
  standalone: false,
  selector: 'app-registration-request-decision',
  templateUrl: './registration-request-decision.component.html',
  styleUrls: ['./registration-request-decision.component.scss'],
})
export class RegistrationRequestDecisionComponent implements OnInit {
  isLoading = true;
  isSuccess = false;
  isInfo = false;
  heading = '';
  message = '';
  request: UserRegistrationRequest;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private registrationRequestService: RegistrationRequestService
  ) {}

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    const decision = (this.route.snapshot.paramMap.get('decision') || '').toLowerCase();

    if (!id || (decision !== 'approve' && decision !== 'decline')) {
      this.showError('Registration request could not be processed.');
      return;
    }

    const request =
      decision === 'approve'
        ? this.registrationRequestService.approve(id)
        : this.registrationRequestService.decline(id);

    request.subscribe({
      next: (data) => {
        this.request = data?.value;
        this.isLoading = false;
        this.isSuccess = true;
        this.heading =
          decision === 'approve'
            ? 'Registration request approved'
            : 'Registration request declined';
        this.message =
          decision === 'approve'
            ? 'The user has been activated and has been notified by email.'
            : 'The request has been declined.';
      },
      error: (err: HttpErrorResponse) => {
        if (this.isAlreadyProcessed(err)) {
          this.showAlreadyProcessed();
          return;
        }

        this.showError(
          err?.error?.message || err?.message || 'This registration request is no longer available.'
        );
      },
    });
  }

  goHome(): void {
    this.router.navigateByUrl('/');
  }

  private isAlreadyProcessed(err: HttpErrorResponse): boolean {
    return /no longer pending/i.test(err?.error?.message || '');
  }

  private showAlreadyProcessed(): void {
    this.isLoading = false;
    this.isSuccess = false;
    this.isInfo = true;
    this.heading = 'Registration request already processed';
    this.message =
      'A decision has already been made on this registration request. No further action is needed.';
  }

  private showError(message: string): void {
    this.isLoading = false;
    this.isSuccess = false;
    this.isInfo = false;
    this.heading = 'Registration request could not be processed';
    this.message = message;
  }
}
